// import React from "react";
// import { Link } from "react-router-dom";
// import "./MegaMenu.css";

// const MegaMenu = ({ categories }) => {
//   // const [activeCategory, setActiveCategory] = useState(0);

//   return (
//     // <div className="mega-menu-container">

//     //   {/* LEFT SIDE */}

//     //   <div className="mega-left">
//     //     {categories.map((cat, index) => (
//     //       <Link
//     //         key={index}
//     //         to={`/shop/${cat.slug}`}
//     //         className={`mega-category ${
//     //           activeCategory === index ? "active" : ""
//     //         }`}
//     //         onMouseEnter={() => setActiveCategory(index)}
//     //       >
//     //         {cat.title}
//     //       </Link>
//     //     ))}
//     //   </div>

//     //   {/* RIGHT SIDE */}

//     //   <div className="mega-right">

//     //     <h3>{categories[activeCategory].title}</h3>

//     //     <div className="mega-grid">

//     //       {categories[activeCategory].items.map((item, index) => (

//     //         <Link
//     //           key={index}
//     //           className="mega-item"
//     //           to={`/shop/${categories[activeCategory].slug}/${item.slug}`}
//     //         >
//     //           {item.title}
//     //         </Link>

//     //       ))}

//     //     </div>

//     //   </div>

//     // </div>
//        <div className="mega-menu-container only-left-menu">
//       <div className="mega-left full-width">
//         {categories.map((cat, index) => (
//           <Link
//             key={index}
//             to={`/shop/${cat.slug}`}
//             className="mega-category"
//           >
//             {cat.title}
//           </Link>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default MegaMenu;
import React from "react";
import { Link } from "react-router-dom";
import "./MegaMenu.css";

const MegaMenu = ({ categories, onNavigate }) => {
  const mid = Math.ceil(categories.length / 2);

  const leftColumn = categories.slice(0, mid);
  const rightColumn = categories.slice(mid);

  return (
    <div className="mega-menu-container">

      <div className="mega-column">
        {leftColumn.map((cat) => (
          <Link
            onClick={onNavigate}
            key={cat.slug}
            to={cat.link || `/shop/${cat.slug}`}
            className="mega-category-card"
          >
            <img
              src={cat.icon}
              alt={cat.title}
              className="mega-category-icon"
            />

            <span>{cat.title}</span>
          </Link>
        ))}
      </div>

      <div className="mega-column">
        {rightColumn.map((cat) => (
          <Link
            onClick={onNavigate}
            key={cat.slug}
            to={cat.link || `/shop/${cat.slug}`}
            className="mega-category-card"
          >
            <img
              src={cat.icon}
              alt={cat.title}
              className="mega-category-icon"
            />

            <span>{cat.title}</span>
          </Link>
        ))}
      </div>

    </div>
  );
};

export default MegaMenu;